import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ReactComponent as PhoneIcon } from '../icons/telephone.svg'

export const ModernMobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  const navLinks = [
    { to: '/', label: 'Inicio' },
    { to: '/payment', label: 'Formas De Pago' },
    { to: '/ift', label: 'Legal' }
  ]

  return (
    <>
      {/* Hamburger Button */}
      <button 
        className={`hamburger ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isOpen}
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`} onClick={closeMenu} />

      {/* Mobile Menu */}
      <nav className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          
          {/* Navigation Links */}
          <div className="mobile-nav-links">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`mobile-nav-link ${location.pathname === link.to ? 'active' : ''}`}
                onClick={closeMenu}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Contact Section */}
          <div className="mobile-contact">
            <a 
              href="tel:8180178779" 
              className="mobile-contact-button"
              onClick={closeMenu}
            >
              <PhoneIcon className="contact-icon" />
              <div className="contact-details">
                <span className="contact-label">Llamar Ahora</span>
                <span className="contact-number">81 8017 8779</span>
              </div>
            </a>
            
            <a 
              href="mailto:Interhomecontacto@gmail.com" 
              className="mobile-email-link"
              onClick={closeMenu}
            >
              Interhomecontacto@gmail.com
            </a>
          </div>

        </div>
      </nav>
    </>
  )
}
